import { createFileRoute, useParams } from '@tanstack/react-router'

import { NotFound } from '../../../../../../../components/organisms/not-found.tsx'
import { PlatformEndorsementHistoryPage } from '../../../../../../../components/pages/backoffice/platform/platform-endorsement-history-page.tsx'
import { PermissionChecker } from '../../../../../../../components/templates/permission-checker.tsx'

export const Route = createFileRoute('/bo/contracts/$subscriptionId/$endorsementType/$endorsementId/history')({
  component: RouteComponent,
})

function RouteComponent() {
  const { endorsementType, endorsementId } = useParams({
    from: '/bo/contracts/$subscriptionId/$endorsementType/$endorsementId/history',
  })

  if (endorsementType !== 'renewals' && endorsementType !== 'endorsements') {
    return <NotFound />
  }

  return (
    <PermissionChecker requiredPermissions={['debugHistory.read']}>
      <PlatformEndorsementHistoryPage endorsementType={endorsementType} endorsementId={endorsementId} />
    </PermissionChecker>
  )
}
